


























































import {Component, Vue, Inject, Watch} from 'vue-property-decorator';
import FlexGridModel, {Column} from '@/models/FlexGridModel';
import {omit} from 'lodash';
import FlexGridSortingTypeEnum from '@/enums/FlexGridSortingTypeEnum';

@Component
export default class FlexGridTableHead extends Vue {
    @Inject() moduleName!: string;
    @Inject() sortable!: boolean;
    @Inject() selectable!: boolean;

    private sortingTypeEnum = FlexGridSortingTypeEnum;

    get mainData(): FlexGridModel | null {
        return this.$store.state[this.moduleName].data;
    }
    get isEditable(): number {
        return this.$store.state[this.moduleName].isEditable;
    }
    get emptyCellsCount(): number {
        return this.$store.getters[`${this.moduleName}/emptyCellsCount`];
    }
    get sortKey(): string | null {
        return this.$store.state[this.moduleName].sortKey;
    }
    get sortIndex(): number | null {
        return this.$store.state[this.moduleName].sortIndex;
    }
    get sortType(): FlexGridSortingTypeEnum {
        return this.$store.state[this.moduleName].sortType;
    }
    get compressed(): boolean {
        return this.$store.state[this.moduleName].compressed;
    }

    get items() {
        if (!this.mainData?.Columns) return [];
        let result: Array<Array<Column>> = [],
            stickyResult: Array<Array<Column>> = [],
            row =
                this.mainData.Config.CountAnchoredColumns !== null
                    ? this.mainData?.Columns.slice(this.mainData?.Config.CountAnchoredColumns)
                    : this.mainData?.Columns,
            stickyRow =
                this.mainData.Config.CountAnchoredColumns !== null
                    ? this.mainData?.Columns.slice(0, this.mainData?.Config.CountAnchoredColumns)
                    : [],
            nextRow: Array<Column> = [],
            nextStickyRow: Array<Column> = [],
            // число, с помощью которого определяется липкий столбец не 1го уровня
            stickySublevelCapacity = 0,
            needSublevelStickyRightBorder = false;

        const getStickyResult = (): void => {
            let temp: Array<Column> = [],
                balanceStickySublevelCapacity = stickySublevelCapacity;
            temp = stickyRow.map((column, index) => {
                if (column.Columns) nextStickyRow = nextStickyRow.concat(column.Columns);
                let item;
                // определяем липкие столбцы 1го уровня
                if (
                    stickyResult.length === 0 &&
                    typeof this.mainData?.Config.CountAnchoredColumns === 'number' &&
                    index < this.mainData.Config.CountAnchoredColumns
                ) {
                    item = {...column, _sticky: true, _last: index === this.mainData.Config.CountAnchoredColumns - 1};
                    if (column.Columns) stickySublevelCapacity += item.ColSpan;
                    if (column.Columns && index === this.mainData.Config.CountAnchoredColumns - 1)
                        needSublevelStickyRightBorder = true;
                }
                // определяем липкие столбцы n-го уровня
                else if (stickyResult.length !== 0 && column.ColSpan <= balanceStickySublevelCapacity) {
                    item = {
                        ...column,
                        _sticky: true,
                        _last: column.ColSpan === balanceStickySublevelCapacity && needSublevelStickyRightBorder,
                    };
                    balanceStickySublevelCapacity -= column.ColSpan;
                } else {
                    item = {...column};
                }
                return omit(item, ['Columns']);
            });
            stickyResult.push(temp);
            if (nextStickyRow.length > 0) {
                stickyRow = [...nextStickyRow];
                nextStickyRow = [];
                return getStickyResult();
            }
        };
        const getResult = (): void => {
            let temp: Array<Column> = [];
            row.forEach(column => {
                if (column.Columns) nextRow = nextRow.concat(column.Columns);
                temp.push(omit(column, ['Columns']));
            });
            result.push(temp);
            if (nextRow.length > 0) {
                row = [...nextRow];
                nextRow = [];
                return getResult();
            }
        };

        getStickyResult();
        getResult();

        if (result.length > stickyResult.length) {
            let n = result.length - stickyResult.length;
            for (let i = 1; i <= n; i++) stickyResult.push([]);
        }
        this.$emit('update-fix-cells');

        return stickyResult.map((item: any, index) => {
            if (Array.isArray(item) && Array.isArray(result[index])) return item.concat(result[index]);
            else if (!Array.isArray(item) && Array.isArray(result[index])) return result[index];
            return item;
        });
    }

    get lastRowTHColspan() {
        if (this.mainData) {
            return (
                this.mainData?.Columns.reduce((summ, current) => summ + current.ColSpan, 0) +
                this.emptyCellsCount +
                Number(this.isEditable) +
                Number(this.selectable)
            );
        } else return 0;
    }

    onClick({Key, Type, Index}: Column) {
        this.$emit('sort:by', {
            key: Key,
            type: Type,
            index: Index,
        });
    }
}
